import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  testimonial: PropTypes.shape({
    testimonial: PropTypes.string.isRequired,
    trainer: PropTypes.string.isRequired,
    trainerProfile: PropTypes.string.isRequired,
    trainerPicture: PropTypes.string.isRequired,
    position: PropTypes.string,
    company: PropTypes.string,
    companyUrl: PropTypes.string,
  }).isRequired,
};

export default function TrainerTestimonial({
  testimonial: t,
}) {
  return (
    <figure className="relative shadow-lg lg:shadow-2xl rounded-xl flex-none grid grid-cols-1 lg:grid-cols-12 overflow-hidden bg-white z-20">
      <div className="col-span-1 lg:col-span-4 px-6 pt-6 md:p-10 flex flex-col">
        <div className="flex w-full rounded-t-xl lg:rounded-xl overflow-hidden relative z-20 lg:h-full">
          <img
            src={t.trainerPicture}
            alt={t.trainer}
            className="rounded-t-xl lg:rounded-xl bg-green-100 w-full h-auto block lg:h-full object-cover" 
            loading="lazy"
          />
        </div>
      </div>
      <div className="col-span-1 lg:col-span-8 px-6 pb-6 md:pl-0 md:p-10 lg:pb-20 space-y-10">
        <blockquote className="text-gray-900 font-medium leading-relaxed lg:leading-8 text-lg lg:text-xl">
          <svg width="45" height="36" className="mb-5 fill-current text-green-100">
            <path d="M13.415.001C6.07 5.185.887 13.681.887 23.041c0 7.632 4.608 12.096 9.936 12.096 5.04 0 8.784-4.032 8.784-8.784 0-4.752-3.312-8.208-7.632-8.208-.864 0-2.016.144-2.304.288.72-4.896 5.328-10.656 9.936-13.536L13.415.001zm24.768 0c-7.2 5.184-12.384 13.68-12.384 23.04 0 7.632 4.608 12.096 9.936 12.096 4.896 0 8.784-4.032 8.784-8.784 0-4.752-3.456-8.208-7.776-8.208-.864 0-1.872.144-2.16.288.72-4.896 5.184-10.656 9.792-13.536L38.183.001z"></path>
          </svg>
          <p>
            {t.testimonial}
          </p>
        </blockquote>
        <figcaption className="text-lg">
          <div className="flex-auto font-medium">
            {t.trainer}
            <br />
            <span className="text-green-500 font-normal text-base">
              {`${t.position} ${t.company}`}
            </span>
          </div>
        </figcaption>
      </div>
    </figure>
  );
}

TrainerTestimonial.defaultProps = defaultProps;
TrainerTestimonial.propTypes = propTypes;
